import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { BounceLoader } from 'react-spinners';
import './styles.scss';
import configs from 'configs';

import _ from 'lodash';
import messages from './messages';

const loader = props => {
  const { loading, message } = props;
  const id = _.uniqueId('Loader-');

  if (loading) {
    return (
      <div id={id} className="loader">
        <BounceLoader loading={loading} color={configs.colors.main} />
        {message || <FormattedMessage {...messages.message} tagName="p" />}
      </div>
    );
  }

  return null;
};

loader.defaultProps = {
  loading: false,
};

loader.propTypes = {
  loading: PropTypes.bool,
};

export default loader;
